import { render, staticRenderFns } from "./UIToggle.vue?vue&type=template&id=8fe838a0&"
import script from "./UIToggle.vue?vue&type=script&lang=js&"
export * from "./UIToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports